import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { cn } from "@/lib/utils";

const tempStyles = {
  hot: "bg-red-50 text-red-600 hover:bg-red-50",
  warm: "bg-amber-50 text-amber-600 hover:bg-amber-50",
  cold: "bg-slate-100 text-slate-500 hover:bg-slate-100",
};

export function RecentLeads({ leads = [] }) {
  return (
    <Card className="shadow-sm" data-testid="recent-leads">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base font-semibold text-slate-900">Recent Leads</CardTitle>
        <p className="text-xs text-slate-400">Latest inbound enquiries</p>
      </CardHeader>
      <CardContent className="px-0">
        <Table>
          <TableHeader>
            <TableRow className="border-slate-200 hover:bg-transparent">
              <TableHead className="pl-6 text-xs uppercase tracking-wider text-slate-400">Name</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-slate-400">Interest</TableHead>
              <TableHead className="text-xs uppercase tracking-wider text-slate-400">Source</TableHead>
              <TableHead className="pr-6 text-right text-xs uppercase tracking-wider text-slate-400">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.map((lead) => (
              <TableRow key={lead.id} className="border-slate-100" data-testid={`recent-lead-row`}>
                <TableCell className="pl-6">
                  <p className="font-medium text-slate-900">{lead.name}</p>
                  <p className="font-mono text-xs text-slate-400">{lead.phone}</p>
                </TableCell>
                <TableCell className="text-sm text-slate-600">{lead.interest}</TableCell>
                <TableCell className="text-sm text-slate-600">{lead.source}</TableCell>
                <TableCell className="pr-6 text-right">
                  <Badge className={cn("capitalize", tempStyles[lead.priority] || tempStyles.cold)}>
                    {lead.priority}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
